import angular from 'angular';
import { TableBuilderActions } from '@/hybrid/tableBuilder/tableBuilder.actions';

const dependencies = ['Sq.AppConstants', 'Sq.Investigate'];

export default angular.module('Sq.TableBuilder', dependencies).service('sqTableBuilderActions', TableBuilderActions);
